module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-rv"
  }, [_c('div', {
    staticClass: "loading-rv-bg"
  }, [_c('div', {
    staticClass: "loading-rv-sand"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading-rv-cloud1"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading-rv-cloud2"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading-rv-cloud3"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading-rv-mountain"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading-rv-tree1"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading-rv-car-container"
  }, [_c('div', {
    staticClass: "loading-rv-wheel-mark"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading-rv-car"
  }, [_c('div', {
    staticClass: "loading-rv-wheel loading-rv-wheel-front"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading-rv-wheel loading-rv-wheel-back"
  })]), _vm._v(" "), _c('div', {
    staticClass: "loading-rv-car-shadow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "loading-rv-tree2"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4302687c"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading/car.vue
// module id = 277
// module chunks = 107